import React from 'react';
import PropTypes from 'prop-types';
import { getClickAttrs } from '../../Analytics/gtag';
import { getFindSportTypeEventsSearchUrl } from '../../../utils/events';
import styles from './sportEventCard.scss';

const SportEventCard = (props) => {
    const { history, isTennis, 'data-testid': dataTestId } = props;

    const sport = isTennis ? 'tennis' : 'pickleball';
    const sportFilter = isTennis ? { showTennisContent: true } : { showPickleballContent: true };

    const handleOnFindEventsClick = () => {
        const url = getFindSportTypeEventsSearchUrl(sportFilter);
        history.push(url);
    };

    return (
        <div className={styles.cardContainer}>
            <div className={styles.cardContent}>
                <img src={`/img/icons/${sport}_icon_with_color.svg`} alt={`${sport} icon`} className={styles.cardIcon} />
                <h5 className="fs20 fw450" data-testid={dataTestId && `${dataTestId}.title`}>Find a {sport} event</h5>
                <p className={styles.cardText} data-testid={dataTestId && `${dataTestId}.description`}>Play in a level-based event near you.</p>
                <button
                    type="button"
                    className={`btn btn-inv text-uppercase`}
                    data-testid={dataTestId && `${dataTestId}.find-event-btn`}
                    onClick={handleOnFindEventsClick}
                    {...getClickAttrs({
                        category: 'Global Search See All',
                        context: `See all events: ${sport}`,
                        location: 'Global search CTA',
                    })}
                >
                    Find an event
                </button>
            </div>
        </div>
    );
};

SportEventCard.propTypes = {
    history: PropTypes.instanceOf(Object),
    isTennis: PropTypes.bool,
    'data-testid': PropTypes.string,
};
SportEventCard.defaultProps = {
    history: {},
    isTennis: false,
    'data-testid': null,
};

export default SportEventCard;
